import React from 'react';

const CopyrightFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="absolute right-3 bottom-0 p-2 text-sm text-gray-600">
      Copyright © {currentYear} All Rights Reserved.{" "}
      <a
        href="https://www.enfusesolutions.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary-color hover:underline"
      >
        Tagi5
      </a>
    </div>
  );
};

export default CopyrightFooter;